import { Dialog } from "primereact/dialog";

export default function Modal
  ({
    isOpen,
    onClose,
    title,
    subtitle,
    children,
    footer,
    className,
    style,
  }) {
  // Header customizado (equivalente ao seu cabeçalho)

  const renderHeader = (
    <div className="flex items-start justify-between w-full">
      <div>
        {title && (
          <h3 className="font-display text-lg leading-6 font-semibold text-foreground">
            {title}
          </h3>
        )}
        {subtitle && (
          <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>

    </div>
  );

  const renderFooter = footer ? (
    <div className="px-0 py-0 w-full">{footer}</div>
  ) : null;

  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      header={renderHeader}
      footer={renderFooter}
      style={style}
      blockScroll={true}
      className={`${className || ""}`}
      contentClassName="p-0"
    >
      <div>
        {children}
      </div>
    </Dialog>
  );

}